import { render, staticRenderFns } from "./ListDragonTiger.vue?vue&type=template&id=4784a306&"
import script from "./ListDragonTiger.vue?vue&type=script&lang=js&"
export * from "./ListDragonTiger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports